import { v4 as uuidv4 } from 'uuid';

import { getStoredData, setStoredData } from '../../../utils/sessionStorageHelpers';

export const STEPUP_CSRF_STATE_KEY = 'aro_remediation_csrf_state';
const STEPUP_CSRF_STATE_PREFIX = 'su';

/**
 * Generates a CSRF state value and stores it so the (separate) Verification Result
 * screen can validate it against the state ID.me returns on callback.
 */
export const generateAndStoreStepUpState = (): string => {
  const state = uuidv4();
  setStoredData(STEPUP_CSRF_STATE_KEY, state, STEPUP_CSRF_STATE_PREFIX);

  return state;
};

export const getStoredStepUpState = (): string => getStoredData(STEPUP_CSRF_STATE_KEY, STEPUP_CSRF_STATE_PREFIX);
